module.exports = __webpack_public_path__ + "static/cream-bread-bd3296316ae4369432caea96653fc997.jpg";